//this file mange ui filters logic and take care to call dataAction to trigger data update (dataAction) when necessary

import { defineStore } from "pinia";

export const useUiStore = defineStore("ui", {
  state: () => ({
    options: {
      category: null,
      disposition: null,
      decade: null,
      year: null,
    },
  }),
  getters: {
    getOptions: (state) => state.options,
  },
  actions: {
    setOptions(value) {
      this.options = value;
    },
  },
});
